import { render, staticRenderFns } from "./allergy-list.vue?vue&type=template&id=dbd1baa2&scoped=true&"
import script from "./allergy-list.vue?vue&type=script&lang=js&"
export * from "./allergy-list.vue?vue&type=script&lang=js&"
import style0 from "./allergy-list.vue?vue&type=style&index=0&id=dbd1baa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd1baa2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oohira/sites/giontsujiri/giontsujiri.co.jp_brand_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbd1baa2')) {
      api.createRecord('dbd1baa2', component.options)
    } else {
      api.reload('dbd1baa2', component.options)
    }
    module.hot.accept("./allergy-list.vue?vue&type=template&id=dbd1baa2&scoped=true&", function () {
      api.rerender('dbd1baa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/store/allergy/allergy-list.vue"
export default component.exports